import { Link } from 'react-router-dom';
import { FaqList } from '@/components/landing/FaqList';
import { allFaqs, landingFaqs } from '@/lib/faq';
import { useLangHref, useT } from '@/lib/useLang';

export function Faq() {
  const t = useT();
  const withLang = useLangHref();

  return (
    <section id="faq" className="nz-faq">
      <div className="nz-faq__head">
        <h2 className="nz-h2">{t.faqH2}</h2>
        <Link className="nz-faq__all" to={withLang('/faq')}>
          {t.faqSeeAll.replace('{count}', String(allFaqs(t).length))} →
        </Link>
      </div>

      <FaqList items={landingFaqs(t)} idPrefix="nz-faq" openFirst />
    </section>
  );
}
